import { render, staticRenderFns } from "./BasketItems.vue?vue&type=template&id=320972a4&scoped=true&"
import script from "./BasketItems.vue?vue&type=script&lang=ts&"
export * from "./BasketItems.vue?vue&type=script&lang=ts&"
import style0 from "./BasketItems.vue?vue&type=style&index=0&id=320972a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320972a4",
  null
  
)

export default component.exports